import { useEffect, useState } from "react";
import { endpoints } from "serverDetails";
import api, { ApiResponse } from "api";


type Details = {
  farms: Farm[];
  crop_types: CropType[];
};

type CropType = {
  crop_id: number;
  crop_name: string;
};
type ParsedCropType =  { name: string; id: number }

type Farm = {
  farm_id: number;
  farm_name: string;
  fields: Field[];
};

type Field = {
  field_id: number;
  field_name: string;
};

type ParsedFarm = {
  id: Farm["farm_id"] 
   name: Farm["farm_name"];
   fields: Farm["fields"];
  }

type UseFetchFieldDetails = (
) => [
  farmList: ParsedFarm[],
cropTypeList: ParsedCropType[],
]

export const useFetchFieldDetails:UseFetchFieldDetails = () => {
  const [farmList, setFarmList] = useState<ParsedFarm[]
  >([]);
      const [cropTypeList, setCropTypeList] = useState<
      ParsedCropType[]
      >([]);
  useEffect(() => {

    const getFarmFieldList = async () => {
      const url = endpoints.reportsModule.getReportsDetails;
      const results = await api.get<ApiResponse<Details, unknown>>(url, {});
      if (results && results.data && results.data.details) {
        if (Array.isArray(results.data.details.farms)) {
          setFarmList(
            results.data.details.farms
              .filter(({ fields }) => fields !== null)
              .map(({ farm_name, farm_id, fields }) => ({
                name: farm_name,
                id: farm_id,
                fields,
              }))
          );
        }
        if (Array.isArray(results.data.details.crop_types)) {
          setCropTypeList(
            results.data.details.crop_types.map(({ crop_id, crop_name }) => ({
              name: crop_name,
              id: crop_id,
            }))
          );
        }
      }
    };
    getFarmFieldList();
  }, []);
return [farmList,
cropTypeList]
};
